import { ABaseModel } from '../abstracts/ABaseModel.js';
import { ICountry, ICountryListResult, IRegion, IRegionListResult } from '../interfaces/Country.js';
import { ListResult } from './List.js';

/**
 * Country
 */
class Country extends ABaseModel implements ICountry {
  code: string;
  name: string;
  currencyCode: string;
  dialingCode: string;
  dialingDefault: boolean;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * CountryListResult
 */
class CountryListResult extends ListResult implements ICountryListResult {
  declare items: Array<Country>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * Region
 */
class Region extends ABaseModel implements IRegion {
  code: string;
  name: string;
  countries: Array<Country>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * RegionListResult
 */
class RegionListResult extends ListResult implements IRegionListResult {
  declare items: Array<Region>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Country, CountryListResult, Region, RegionListResult };
